import { COUNTRY_NAMES, CountryCode } from '../../models/country';
import { COUNTRY_TO_FLAG } from '../../utils/languageUtils';
import { AutocompleteOption } from './autocompleteInput';

// Country options - reusable constant
export const COUNTRY_OPTIONS: AutocompleteOption<CountryCode>[] = Object.entries(COUNTRY_NAMES).map(([code, name]) => ({
  label: name,
  value: code as CountryCode,
  icon: COUNTRY_TO_FLAG[code] || '❌',
}));

// Helper to get country option by code
export const getCountryOption = (code?: string): AutocompleteOption<CountryCode> | null => COUNTRY_OPTIONS.find(o => o.value === code) ?? null;

